import type { Observable } from 'rxjs';
import { Inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { Application } from '../../../../common/models/application.interface';
import { ApiResponse } from '../../../../common/models/api-response.interface';
import { APP_SETTINGS } from '../../app-settings';

@Injectable()
export class ApplicationService {
    constructor(
        private http: HttpClient,
        @Inject(APP_SETTINGS) private appSettings
    ) {}

    public list(): Observable<ApiResponse<Application[]>> {
        return this.http.get<ApiResponse<Application[]>>(
            this.appSettings.apiEndpoint + 'applications'
        );
    }

    getMaintenanceModeConfig(): Observable<ApiResponse<any>> {
        return this.http.get<ApiResponse<any>>(
            `${this.appSettings.apiEndpoint}common/maintenance-mode`
        );
    }
}
